import { Stack, Switch, Typography } from '@mui/material'
import { HelpCircleIcon } from 'lucide-react'

import { InfoTooltip } from '@/views/NewBuilder/components/InfoTooltip/InfoTooltip'

export function GenerateShortAnswersBulkImport({
  checked,
  handleChange,
}: {
  checked: boolean
  handleChange: (checked: boolean) => void
}) {
  return (
    <Stack
      sx={{
        borderRadius: '16px',
        gap: '6px',
      }}
    >
      <Typography fontWeight="medium">Generate Answers</Typography>
      <Stack
        sx={{
          flexDirection: 'row',
          gap: '6px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            gap: '6px',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <StarsIcon />
          <Typography
            fontWeight="medium"
            sx={{
              background: 'linear-gradient(45deg, #FF6C6C 0%, #DD7BFF 100%)',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Generate with AI
          </Typography>
          <InfoTooltip title="AI compares student responses to the correct answers generated from the prompt. While this can be very helpful, please review the results for accuracy, as AI may occasionally make mistakes.">
            <HelpCircleIcon color="#98A2B3" size={12} />
          </InfoTooltip>
        </Stack>

        <Switch
          checked={checked}
          onChange={(_, c) => {
            handleChange(c)
          }}
        />
      </Stack>
    </Stack>
  )
}

function StarsIcon() {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3201_96691)">
        <path
          d="M12.333 5.33203V1.9987M3.66634 13.9987V10.6654M10.6663 3.66536H13.9997M1.99967 12.332H5.33301M4.33301 1.33203L3.81004 2.37798C3.63304 2.73196 3.54455 2.90895 3.42632 3.06233C3.32141 3.19843 3.1994 3.32044 3.06331 3.42534C2.90993 3.54357 2.73294 3.63207 2.37895 3.80906L1.33301 4.33203L2.37895 4.855C2.73294 5.032 2.90993 5.12049 3.06331 5.23872C3.1994 5.34363 3.32141 5.46564 3.42632 5.60173C3.54455 5.75511 3.63304 5.9321 3.81004 6.28609L4.33301 7.33203L4.85598 6.28609C5.03297 5.9321 5.12147 5.75511 5.2397 5.60173C5.3446 5.46564 5.46661 5.34363 5.60271 5.23872C5.75609 5.12049 5.93308 5.032 6.28706 4.855L7.33301 4.33203L6.28706 3.80906C5.93308 3.63207 5.75609 3.54357 5.60271 3.42534C5.46661 3.32044 5.3446 3.19843 5.2397 3.06233C5.12147 2.90895 5.03297 2.73196 4.85598 2.37798L4.33301 1.33203ZM11.333 7.9987L10.6989 9.26687C10.5219 9.62085 10.4334 9.79784 10.3152 9.95122C10.2103 10.0873 10.0883 10.2093 9.9522 10.3142C9.79882 10.4325 9.62183 10.521 9.26784 10.6979L7.99968 11.332L9.26784 11.9661C9.62183 12.1431 9.79882 12.2316 9.9522 12.3498C10.0883 12.4547 10.2103 12.5767 10.3152 12.7128C10.4334 12.8662 10.5219 13.0432 10.6989 13.3972L11.333 14.6654L11.9671 13.3972C12.1441 13.0432 12.2326 12.8662 12.3508 12.7128C12.4557 12.5767 12.5777 12.4547 12.7138 12.3498C12.8672 12.2316 13.0442 12.1431 13.3982 11.9661L14.6663 11.332L13.3982 10.6979C13.0442 10.521 12.8672 10.4325 12.7138 10.3142C12.5777 10.2093 12.4557 10.0873 12.3508 9.95122C12.2326 9.79784 12.1441 9.62085 11.9671 9.26687L11.333 7.9987Z"
          stroke="url(#paint0_linear_3201_96691)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_3201_96691"
          x1="1.3328"
          x2="14.6662"
          y1="14.6653"
          y2="1.33187"
        >
          <stop stopColor="#FF6C6C" />
          <stop offset="1" stopColor="#DD7BFF" />
        </linearGradient>
        <clipPath id="clip0_3201_96691">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  )
}
